export const popoutConstants = {
    SPINNER_SHOW: 'POPOUT_SPINNER_SHOW',
    CUSTOM_SHOW: 'POPOUT_CUSTOM_SHOW',

    CLEAR: 'POPOUT_CLEAR'
};